/**
 * GxP profile synthesis aligned with ProviderService MyVendorGxpHelper /
 * Innovation-Lab vendorDocumentUtils (deterministic from name + services).
 */

const CORE_GXPS = ["GCP", "GLP", "GMP", "GVP"];

const LAB_SERVICE_MARKERS = [
  "Central Lab",
  "Biomarker",
  "Bioanalytical",
  "Specialty (incl. DMPK)",
  "Biomarker Lab",
  "Bioanalytical Lab",
];

const APPLICABLE_SECONDARY_GXPS = [
  "GLP",
  "GMP",
  "GVP",
  "GAMP",
  "GDP",
  "GCDMP",
  "GDocP",
  "GEP",
  "GMLP",
  "GPP",
  "GSP",
  "GTP",
  "GTraP/GTrP",
];

function hasLabService(services = []) {
  return services.some((service) =>
    LAB_SERVICE_MARKERS.some((lab) =>
      String(service).toLowerCase().includes(lab.toLowerCase())
    )
  );
}

export function getDemonstratedGxPs(
  providerName,
  serviceCategories = [],
  fromCompletedRequests = []
) {
  const set = new Set();

  if (serviceCategories.length > 0) {
    set.add("GCP");
    if (hasLabService(serviceCategories)) {
      set.add("GLP");
    }
  }

  (fromCompletedRequests || []).forEach((gxp) => {
    const canonical = CORE_GXPS.find(
      (core) => core.toLowerCase() === String(gxp || "").toLowerCase()
    );
    if (canonical) set.add(canonical);
  });

  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

export function getApplicableGxPs(
  providerName,
  serviceCategories = [],
  demonstratedGxPs = []
) {
  if (!serviceCategories.length) return [];

  const hash = String(providerName || "")
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0) % 100;
  const numGxPs = hash < 50 ? 1 : hash < 75 ? 2 : hash < 90 ? 3 : 4;

  const gxpSet = new Set(["GCP"]);
  for (let i = 0; i < numGxPs - 1 && i < APPLICABLE_SECONDARY_GXPS.length; i += 1) {
    gxpSet.add(APPLICABLE_SECONDARY_GXPS[(hash + i * 3) % APPLICABLE_SECONDARY_GXPS.length]);
  }

  (demonstratedGxPs || []).forEach((gxp) => {
    if (gxp) gxpSet.add(gxp);
  });

  return Array.from(gxpSet).sort((a, b) => a.localeCompare(b));
}

/** Fill GxP arrays when API omitted them but services are present. */
export function ensureVendorGxPProfile(vendor = {}) {
  const services = vendor.serviceCategories || vendor.services || [];
  let demonstratedGxPs = vendor.demonstratedGxPs || [];
  let applicableGxPs = vendor.applicableGxPs || [];

  if (!demonstratedGxPs.length && !applicableGxPs.length && services.length > 0) {
    demonstratedGxPs = getDemonstratedGxPs(vendor.name, services);
    applicableGxPs = getApplicableGxPs(vendor.name, services, demonstratedGxPs);
  }

  return {
    ...vendor,
    demonstratedGxPs,
    applicableGxPs,
    gxps: demonstratedGxPs,
  };
}
